package io.horion.cv.api.datasource

sealed class Endpoint(val path: String){
    data object Root: Endpoint(path = "/")
    data object Status: Endpoint(path = "/status")
    data object Cv: Endpoint(path = "/cv/generate")
    data object Save: Endpoint(path = "/cv/save")
    data object UploadImage: Endpoint(path = "/cv/upload")
    data object Update: Endpoint(path = "/cv/update")
    data object DeleteCv: Endpoint(path = "/cv/delete")
    data object Check: Endpoint(path = "/cv/check")
    data object CheckModel: Endpoint(path = "/cv/model")

    data object History: Endpoint(path = "/cv/history")

    data object FindCv: Endpoint(path = "/cv/find")
    data object FindCvById: Endpoint(path = "/cv/find/id")
    //motivation
    data object Motivation: Endpoint(path = "/motivation")
    data object MotivationGenerate: Endpoint(path = "/motivation/generate")
    data object UpdateMotivation: Endpoint(path = "/motivation/update")
    data object DeleteMotivation: Endpoint(path = "/motivation/delete")
    data object CheckMotivation: Endpoint(path = "/motivation/check")
    data object CheckMotivationModel: Endpoint(path = "/motivation/model")
    data object HistoryMotivation: Endpoint(path = "/motivation/history")
    data object FindMotivationById: Endpoint(path = "/motivation/find/id")

    //job
    data object JobCreate: Endpoint(path = "/job/create")
    data object JobUpdate: Endpoint(path = "/job/update")
    data object JobDelete: Endpoint(path = "/job/delete")
    data object JobFind: Endpoint(path = "/job/find")
    data object FindJobsByEnterpriseUuid : Endpoint(path = "/job/enterprise/find")
    data object FindAll : Endpoint(path = "/job/find/all")

    //applyjob
    data object JobApply: Endpoint(path = "/job/apply")
    data object JobGetApplies: Endpoint(path = "/job/applies")
    data object JobUpdateApplyStatus: Endpoint(path = "/job/apply/status")


    data object Exchange : Endpoint(path = "/token/exchange")
    data object Payment: Endpoint(path = "/payment")
}